import React from "react";
import { Helmet } from "react-helmet-async";
import {
  FaSchool,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaMobileAlt,
  FaAndroid,
  FaApple,
  FaShieldAlt,
  FaVideo,
  FaStream,
  FaTasks,
  FaUsers,
  FaStore,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import "../styles/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing-page">
      <Helmet>
        <title>Pricing - Pathshala Sanchalak | Lambdanest Solutions LLP</title>
        <meta
          name="description"
          content="Flexible pricing for Pathshala Sanchalak (Chhaatr & Adhyapak apps) and Online Pathshala (subscription-based course sales). Start free or choose white-labeled plans from ₹600/month."
        />
      </Helmet>

      <header className="pricing-hero section-padding">
        <div className="container">
          <div className="pricing-hero__eyebrow">Lambdanest Solutions LLP</div>
          <h1 className="pricing-hero__title">Simple, transparent pricing</h1>
          <p className="pricing-hero__subtitle">
            Choose the plan that fits your institute or creator business. Start free and
            scale with white‑label branding when you’re ready.
          </p>
          <div className="pricing-hero__badges">
            <span className="badge"><FaAndroid /> Android</span>
            <span className="badge"><FaApple /> iOS</span>
            <span className="badge"><FaShieldAlt /> Secure & Reliable</span>
          </div>
        </div>
      </header>

      <section className="section-padding">
        <div className="container">
          <div className="section-header">
            <h2><FaSchool style={{ marginRight: 8 }} /> 1. Pathshala Sanchalak</h2>
            <p>
              Manage schools and coaching institutes with dedicated apps —{" "}
              <strong>Chhaatr</strong> for students and <strong>Adhyapak</strong> for teachers.
            </p>
          </div>

          <div className="pricing-grid">
            <div className="plan-card plan-card--highlight">
              <div className="plan-card__header">
                <div className="plan-card__title">
                  <FaUserGraduate /> Free Plan (No White‑Labeling)
                </div>
                <div className="plan-card__price">Free</div>
              </div>
              <p className="plan-card__desc">
                Ideal for getting started quickly without custom branding.
              </p>
              <ul className="feature-list">
                <li><FaTasks /> Full access to Pathshala Sanchalak LMS</li>
                <li><FaUsers /> Student management</li>
                <li><FaChalkboardTeacher /> Course management</li>
                <li><FaStream /> Basic analytics</li>
                <li><FaShieldAlt /> Admin portal (web dashboard) for management</li>
              </ul>
              <div className="plan-card__note">
                Note: Branded mobile apps are available with the white‑label plan.
              </div>
            </div>

            <div className="plan-card plan-card--highlight">
              <div className="plan-card__header">
                <div className="plan-card__title">
                  <FaMobileAlt /> Your Brand of Pathshala Sanchalak
                </div>
                <div className="plan-card__price">from ₹600<span>/month</span></div>
              </div>
              <p className="plan-card__desc">
                A fully branded experience with your institute’s identity.
              </p>
              <ul className="feature-list">
                <li><FaMobileAlt /> White‑labeled mobile apps (Chhaatr & Adhyapak)</li>
                <li><FaStore /> Published under your institute/tutor’s name</li>
                <li><FaShieldAlt /> Custom branding (logo, theme, colors)</li>
                <li><FaStream /> Premium dashboards and reporting</li>
                <li><FaVideo /> Higher storage and usage limits</li>
                <li><FaAndroid /> Google Play Store and <FaApple /> Apple App Store</li>
              </ul>
              <div className="feature-subtitle">Pricing varies by:</div>
              <ul className="feature-list inline">
                <li>Students</li>
                <li>Features</li>
                <li>Storage &amp; video bandwidth</li>
                <li>Integrations</li>
              </ul>
              <div className="plan-card__note">
                👉 Custom quotes start at ₹600/month (excl. taxes).
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding section-alt">
        <div className="container">
          <div className="section-header">
            <h2><FaStore style={{ marginRight: 8 }} /> 2. Online Pathshala</h2>
            <p>
              A digital‑first LMS for creators and tutors to sell courses and content at scale with a{" "}
              <strong>subscription‑based model</strong>.
            </p>
          </div>

          <div className="plan-card">
            <div className="plan-card__header">
              <div className="plan-card__title">
                <FaMobileAlt /> White‑Labeled Plans
              </div>
              <div className="plan-card__price">from ₹600<span>/month</span></div>
            </div>
            <p className="plan-card__desc">
              All the tools you need to launch and scale your online academy.
            </p>
            <div className="feature-subtitle">All plans include:</div>
            <ul className="feature-list">
              <li><FaMobileAlt /> Branded mobile app</li>
              <li><FaShieldAlt /> Admin portal for content, users and subscriptions</li>
              <li><FaStore /> Course marketplace setup</li>
              <li><FaVideo /> Digital content hosting &amp; secure video streaming</li>
              <li><FaUsers /> Student enrollment &amp; progress tracking</li>
              <li><FaTasks /> Online test engine</li>
              <li><FaStream /> Integrated payment gateway (Razorpay)</li>
              <li><FaChalkboardTeacher /> Instructor &amp; student dashboards</li>
              <li><FaStore /> Subscription and one‑time purchase support</li>
              <li><FaAndroid /> Google Play Store and <FaApple /> Apple App Store</li>
            </ul>
            <div className="plan-card__note">
              👉 Custom quotes start at ₹600/month. We’ll help you choose the right plan for your content and audience size.
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="cta-card">
            <h2>Need a Custom Plan?</h2>
            <p>Every institute and tutor is different. Let’s tailor a plan to your goals.</p>
            <div className="cta-card__contacts">
              <a href="mailto:pathshalasanchalak@gmail.com" className="button primary"><FaEnvelope /> Email: pathshalasanchalak@gmail.com</a>
              <a href="tel:+917457804496" className="button"><FaPhone /> Call: 7457 804 496</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;


